import { motion } from "framer-motion";
import DecodeText from "./DecodeText";
import HudLabel from "./HudLabel";
import DotsText from "./DotsText";
import { icons } from "./icons";
import "./Contact.css";

/** Contact section — gold-outlined pill links built from profile.contacts. */
export default function Contact({ profile }) {
  return (
    <section id="contact" className="section contact">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.5 }}
      >
        <HudLabel className="contact__eyebrow" text="ESTABLISH LINK" />
        <DecodeText as="h2" className="contact__title hud-title" text="Contact" />
        <DotsText
          as="p"
          className="contact__lead"
          text="Have a project, a role, or just want to say hi? Reach out."
        />

        <div className="contact__links">
          {profile.contacts.map((c) => {
            const Icon = icons[c.type];
            const external = c.href.startsWith("http");
            return (
              <a
                key={c.type}
                className="contact__link"
                href={c.href}
                {...(external ? { target: "_blank", rel: "noreferrer" } : {})}
              >
                {Icon && <Icon className="contact__icon" />}
                <span>{c.label}</span>
              </a>
            );
          })}
        </div>
      </motion.div>
    </section>
  );
}
